import { gql, TypedDocumentNode } from '@apollo/client'

import { LABEL_FRAGMENT } from './label'

import type { AbTestsParametersSchemaDTO } from 'features/ab-tests/api/types/abTestsParametersSchemaDTO'

export const VIEWABILITY_TOOLS_FRAGMENT: TypedDocumentNode<
  AbTestsParametersSchemaDTO['viewabilityTools']
> = gql`
  ${LABEL_FRAGMENT}

  fragment viewabilityToolsFragment on AbTestsParametersViewabilityTools {
    lazyLoading {
      ...labelFragment
    }
    label
  }
`
